import AccountAdmin from './AccountAdmin';
import AccountAdminHOC from './AccountAdminHOC';

export default AccountAdminHOC(AccountAdmin);



// WEBPACK FOOTER //
// ./src/pages/AccountAdmin/index.jsx